import { ConnBars } from "@/components/ConnBars";
import { agentOutdated, fmtIdle } from "@/lib/api";

export const MachineRow = ({ m, group, selected, checked, onCheck, onSelect, onOpen, help, latest }) => (
  <div
    data-testid={`machine-row-${m.machine_id}`}
    onClick={(e) => e.detail === 1 && onSelect(m)}
    onDoubleClick={() => onOpen(m)}
    className={`flex items-center gap-4 px-5 py-3 border-b border-slate-200 cursor-pointer select-none ${selected ? "bg-slate-100" : "hover:bg-slate-50"}`}
  >
    <input type="checkbox" checked={!!checked} onClick={(e) => e.stopPropagation()} onDoubleClick={(e) => e.stopPropagation()} onChange={() => onCheck(m)} className="h-5 w-5 accent-blue-600 flex-shrink-0 cursor-pointer" data-testid={`machine-check-${m.machine_id}`} />
    <div className="flex-1 min-w-0 leading-snug">
      <p className="text-[19px] text-slate-900 truncate flex items-center gap-2" data-testid={`machine-name-${m.machine_id}`}>
        {(!m.agent_version || agentOutdated(m.agent_version, latest)) && (
          <span className="h-2.5 w-2.5 rounded-full bg-red-600 flex-shrink-0" data-testid={`machine-outdated-dot-${m.machine_id}`}
            title={`Agent ${m.agent_version || "inconnu"} : à mettre à jour${latest ? ` vers ${latest}` : ""}`} />
        )}
        <span className="truncate">{m.display_name || m.hostname}</span>
        {m.uninstall_requested_at && <span className="rounded bg-slate-700 text-white text-[11px] font-semibold px-1.5 py-0.5 flex-shrink-0" data-testid={`machine-uninstall-badge-${m.machine_id}`}>Désinstallation en attente</span>}
        {help && <span className="rounded bg-red-600 text-white text-[11px] font-semibold px-1.5 py-0.5 flex-shrink-0" data-testid={`machine-help-badge-${m.machine_id}`}>Aide demandée</span>}</p>
      <p className="text-[13px] text-slate-700 truncate">Entreprise : {group?.name || "—"}</p>
      <p className="text-[13px] text-slate-700 truncate">
        Utilisateur : {m.username || "—"} {m.online ? `(inactif ${fmtIdle(m.idle_s)})` : "(hors ligne)"}
      </p>
    </div>
    <ConnBars m={m} />
  </div>
);
